import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogIn, User, Shield, LogOut, Gamepad2 } from "lucide-react";
import { stakeUrl } from "../lib/stake";

export default function TopNav({ variant = "landing" }) {
  const { user, login, logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-5xl">
      <nav className={`glass rounded-full px-5 md:px-6 py-2.5 flex items-center justify-between transition-all ${scrolled ? "glass-strong" : ""}`}>
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo.png" alt="Gumble" className="h-6 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-7 text-[13.5px] text-white/70">
          {loc.pathname === "/" ? (
            <>
              <a href="#games" className="hover:text-white transition-colors">Games</a>
              <a href="#crates" className="hover:text-white transition-colors">Crates</a>
              <Link to="/challenges" className="hover:text-white transition-colors">Challenges</Link>
              <Link to="/news" className="hover:text-white transition-colors" data-testid="nav-news">Journal</Link>
              <Link to="/partner" className="hover:text-white transition-colors" data-testid="nav-partner">Partner</Link>
            </>
          ) : (
            <>
              <Link to="/" className="hover:text-white transition-colors">Studio</Link>
              <Link to="/challenges" className="hover:text-white transition-colors">Challenges</Link>
              <Link to="/news" className="hover:text-white transition-colors" data-testid="nav-news">Journal</Link>
              <Link to="/partner" className="hover:text-white transition-colors" data-testid="nav-partner">Partner</Link>
              {user?.is_admin ? <Link to="/admin" className="hover:text-white transition-colors">Admin</Link> : null}
            </>
          )}
        </div>

        <div className="flex items-center gap-2">
          <a href={stakeUrl("/fr/casino/group/gumble")} target="_blank" rel="noreferrer" title="Play Gumble on Stake"
            className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-[#0A84FF] text-white hover:bg-[#0077ED] transition-colors shadow-[0_6px_18px_-6px_rgba(10,132,255,0.7)]">
            <Gamepad2 className="w-4 h-4" />
          </a>
          {user ? (
            <div className="flex items-center gap-2">
              <Link to="/challenges" className="hidden sm:flex items-center gap-2 pl-1 pr-3 py-1 rounded-full hover:bg-white/5">
                {user.avatar ? <img src={user.avatar} alt="" className="w-6 h-6 rounded-full" /> : <User className="w-4 h-4" />}
                <span className="text-[13px] text-white/85">{(user.global_name || user.username)?.slice(0, 14)}</span>
              </Link>
              {user.is_admin ? <Link to="/admin" title="Admin" className="p-2 rounded-full hover:bg-white/5"><Shield className="w-4 h-4 text-white/70" /></Link> : null}
              <button onClick={logout} title="Sign out" className="p-2 rounded-full hover:bg-white/5"><LogOut className="w-4 h-4 text-white/60" /></button>
            </div>
          ) : (
            <button onClick={login} className="flex items-center gap-2 pl-4 pr-4 py-2 rounded-full bg-white text-black text-[13px] font-semibold hover:bg-white/90 transition-colors">
              <LogIn className="w-4 h-4" /> Sign in
            </button>
          )}
        </div>
      </nav>
    </div>
  );
}
